import ApiService from './api.service.js';
import Config from '../config';

export default {
  async getProfile() {
    return await ApiService.get('/admins/profile', {
      headers: { 'x-service-id': Config.serviceId }
    });
  },
  async updateProfile(userId, data) {
    return await ApiService.put(`/admins/${userId}`, JSON.stringify(data));
  }
};
